import { useState } from 'react';
import { showToast } from '@creditas-ui/react';
import { trackingService } from '@/shared/application/services/TrackingService';
import { Actions, Categories, EventName, Labels } from '@/shared/domain/enums';
import { NewPasswordResetRequest } from '@/shared/infrastructure/clients';
import { useNavigateForm } from '@/shared/application/hooks/useNavigateForm';
import { catchError } from '@/shared/application/services/catchErrorService';
import { updatePassword } from '@/auth/infra/adapters/newPasswordAdapter';

type UseNewPasswordReturn = {
  loading: boolean;
  newPassword: (credentials: NewPasswordResetRequest) => void;
};

export const useNewPassword = (): UseNewPasswordReturn => {
  const { goToPostNewPassword } = useNavigateForm();
  const dispatch = trackingService();
  const [loading, setLoading] = useState<boolean>(false);

  const newPassword = async (credentials: NewPasswordResetRequest) => {
    const categories = [Categories.Partnerships, Categories.Authentication, Categories.NewPassword];
    setLoading(true);

    try {
      dispatch({
        event: EventName.Partners,
        category: categories,
        action: Actions.Submit,
      });
      await updatePassword({
        ...credentials,
      });
      dispatch({
        event: EventName.Partners,
        category: categories,
        action: [Actions.Submit, Labels.Success],
      });
      showToast('Nova senha cadastrada com sucesso', {
        emoji: {
          symbol: '😄',
          label: 'Smile face',
        },
        duration: 5000,
      });
      goToPostNewPassword();
    } catch (error: any) {
      catchError({
        error,
        onRequestError: (err) => {
          dispatch({
            event: EventName.Partners,
            category: categories,
            action: [Actions.Submit, Labels.Error],
            label: err?.response?.data,
          });
        },
      });
      showToast(`Ooops! Algo deu errado. Confira os caracteres e tente novamente!`, {
        emoji: {
          symbol: '😬',
          label: 'Smile face',
        },
        duration: 5000,
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    newPassword,
    loading,
  };
};
